import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConfigProvider, Layout, Menu } from 'antd';

// 引入完整的管理页功能组件（复用现有 TopTank 目录实现）
import TopTankHome from './TopTankHome';
import RegionManagement from './components/admin/RegionManagement.jsx';
import PlatformManagement from './components/admin/PlatformManagement.jsx';
import GameManagement from './components/admin/GameManagement.jsx';
import CountryManagement from './components/admin/CountryManagement.jsx';
import ChannelManagement from './components/admin/ChannelManagement.jsx';
import CrawlConfig from './components/admin/CrawlConfig.jsx';
import TaskManagement from './components/admin/TaskManagement.jsx';
import ChannelVideos from './components/admin/ChannelVideos.jsx';
import './TopTankAdmin.scss';
import { darkTheme } from './theme';

const { Sider, Content } = Layout;
const TAB_CONFIGS = [
  { key: 'home', label: '主页' },
  { key: 'channel-videos', label: '频道视频导出' },
  { key: 'games', label: '游戏管理' },
  { key: 'regions', label: '区域管理' },
  { key: 'countries', label: '国家管理' },
  { key: 'platforms', label: '平台管理' },
  { key: 'channels', label: '频道管理' },
  { key: 'crawl-config', label: '爬虫配置' },
  { key: 'tasks', label: '任务管理' },
];

class TopTankAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'home'
    };
  }

  componentDidMount() {
    this.guardAccess();
  }

  componentDidUpdate(prevProps) {
    const locationChanged = prevProps.location?.pathname !== this.props.location?.pathname;
    const authChanged =
      prevProps.auth?.isAuthenticated !== this.props.auth?.isAuthenticated ||
      prevProps.auth?.user?.role !== this.props.auth?.user?.role;

    if (locationChanged || authChanged) {
      this.guardAccess();
    }
  }

  getAuthInfo = () => {
    const role = this.props.auth?.user?.role;
    const isAdmin = role === 'admin' || role === 'sadmin';
    const isAuthenticated = !!this.props.auth?.isAuthenticated;
    return { role, isAdmin, isAuthenticated };
  };

  getAllowedTabs = () => {
    const { isAdmin } = this.getAuthInfo();
    return isAdmin
      ? ['home', 'games', 'regions', 'countries', 'platforms', 'channels', 'channel-videos', 'crawl-config', 'tasks']
      : ['home', 'channel-videos'];
  };

  extractTabFromPath = () => {
    const path = this.props.location?.pathname || '';
    const parts = path.split('/').filter(Boolean);
    return parts[parts.length - 1] || '';
  };

  redirectToHome = () => {
    if (this.props.router) {
      this.props.router.replace('/');
    } else {
      window.location.href = '/';
    }
  };

  updateActiveTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  navigateToTab = (tab, replace = false) => {
    const allowedTabs = this.getAllowedTabs();
    if (!allowedTabs.includes(tab)) return;
    this.updateActiveTab(tab);

    if (this.props.router) {
      const method = replace ? 'replace' : 'push';
      this.props.router[method](`/top-tank/admin/${tab}`);
    } else {
      window.location.href = `/top-tank/admin/${tab}`;
    }
  };

  guardAccess = () => {
    const { isAuthenticated } = this.getAuthInfo();
    if (!isAuthenticated) {
      this.redirectToHome();
      return;
    }

    const allowedTabs = this.getAllowedTabs();
    const pathTab = this.extractTabFromPath();
    const nextTab = allowedTabs.includes(pathTab) ? pathTab : allowedTabs[0];

    this.updateActiveTab(nextTab);

    if (pathTab && pathTab !== nextTab) {
      this.navigateToTab(nextTab, true);
    } else if (!pathTab && nextTab) {
      this.navigateToTab(nextTab, true);
    }
  };

  handleTabChange = (tab) => {
    const allowedTabs = this.getAllowedTabs();
    if (!allowedTabs.includes(tab)) return;
    this.navigateToTab(tab);
  };

  renderTabContent = (tab) => {
    switch (tab) {
      case 'home':
        return <TopTankHome />;
      case 'regions':
        return <RegionManagement />;
      case 'platforms':
        return <PlatformManagement />;
      case 'games':
        return <GameManagement />;
      case 'countries':
        return <CountryManagement />;
      case 'channels':
        return <ChannelManagement />;
      case 'channel-videos':
        return <ChannelVideos />;
      case 'crawl-config':
        return <CrawlConfig />;
      case 'tasks':
        return <TaskManagement />;
      default:
        return <div className="admin-content">请选择管理功能</div>;
    }
  };

  render() {
    const { activeTab } = this.state;
    const allowedTabs = this.getAllowedTabs();
    const currentTab = allowedTabs.includes(activeTab) ? activeTab : allowedTabs[0];
    const tabsToRender = TAB_CONFIGS.filter(t => allowedTabs.includes(t.key));

    const menuItems = tabsToRender.map(tab => ({
      key: tab.key,
      label: tab.label,
    }));

    return (
      <ConfigProvider theme={darkTheme}>
        <div className="top-tank-admin-container">
          <Layout className="admin-layout">
            <Sider width={220} className="admin-sidebar">
              <Menu
                mode="inline"
                selectedKeys={[currentTab]}
                items={menuItems}
                onClick={({ key }) => this.handleTabChange(key)}
                className="admin-menu"
              />
            </Sider>
            <Content className="admin-content-wrapper">
              {this.renderTabContent(currentTab)}
            </Content>
          </Layout>
        </div>
      </ConfigProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth || {},
});

export default connect(mapStateToProps)(TopTankAdmin);